/** `tidy` marks a guest who booked through the customer's TIDY direct-booking site. */
export type CustomerGuestPlatform = 'airbnb' | 'vrbo' | 'booking_com' | 'tidy' | null;

export interface CustomerGuest {
  id: number;
  name: string | null;
  email: string | null;
  phone: string | null;
  platform: CustomerGuestPlatform;
  created_at: string;
  // Deterministic key of the guest's shared-inbox conversation
  // (format: `customer_account_id-<id>,guest_id-<id>`). Present once a thread exists;
  // used to open an existing guest conversation via `to_chat_room_key`.
  chat_room_key?: string | null;
}

export interface CustomerGuestsPage {
  guests: CustomerGuest[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  perPage: number;
}

export interface CustomerGuestFilters {
  name?: string;
  email?: string;
  phone?: string;
}

export interface CustomerGuestListParams {
  page?: number;
  perPage?: number;
  filters?: CustomerGuestFilters;
}

export interface CustomerGuestCreatePayload {
  name: string;
  email?: string;
  phone?: string;
}

export type CustomerGuestUpdatePayload = Partial<CustomerGuestCreatePayload>;

export const CUSTOMER_GUESTS_CHANGED_EVENT = 'customer-guests:changed';
